import React from "react";

function AdminUnderReview() {
  return <div>AdminUnderReview</div>;
}

export default AdminUnderReview;
